import _JSXStyle from "styled-jsx/style";
import React from 'react';

var Ellipsis = function Ellipsis(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("span", {
    className: "jsx-3878632172"
  }, children, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "3878632172"
  }, "span.jsx-3878632172{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;min-width:0;}"));
};

export default React.memo(Ellipsis);